import dayjs from 'dayjs';

import { utcToLocalDateStr } from '@/shared/lib/dates';
import {
  FilterFieldConfig,
  FilterValues,
} from '@/shared/ui/GeneratikTable/GeneratikTableFilterPanel.types';

export default function buildFilterValue(
  field: FilterFieldConfig,
  rawValue: unknown,
): FilterValues[string] | undefined {
  const str = String(rawValue ?? '');

  switch (field.type) {
    case 'date-range': {
      const iso = dayjs(rawValue as string).isValid() ? utcToLocalDateStr(rawValue as string) : str;
      return { start: iso, end: iso };
    }
    case 'number-range':
    case 'currency-range':
      return { min: str, max: str };
    case 'slider':
      return { min: Number(rawValue), max: Number(rawValue) };
    case 'autocomplete':
      if (field.multiple !== false) {
        const option = field.options?.find((o) => o.label === str);
        return [option ? option.value : str];
      }
      return field.options?.find((o) => o.label === str)?.value ?? str;
    case 'checkbox-list': {
      const option = field.options?.find((o) => o.label === str);
      return [option ? option.value : str];
    }
    default:
      return field.options?.find((o) => o.label === str)?.value ?? str;
  }
}
